import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
// Copyright 2017-2022 @polkadot/ui-shared authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2016 Dan Finlay
export function container(diameter) {
  var background = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'white';
  var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var _style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var element = document.createElement('div');
  var style = Object.assign({
    background: background,
    borderRadius: "".concat(diameter / 2, "px"),
    display: 'inline-block',
    height: "".concat(diameter, "px"),
    margin: '0px',
    overflow: 'hidden',
    padding: '0px',
    width: "".concat(diameter, "px")
  }, _style);
  element.className = className;
  element.style.background = background;
  Object.keys(style).forEach(function (key) {
    element.style[key] = style[key];
  });
  return element;
}